import { memo } from "react";

import { WorkerPool } from "types/generated";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";

import WorkerPoolResetAction from "../WorkerPool/ResetAction";
import WorkerPoolDeleteAction from "../WorkerPool/DeleteAction";
import WorkerPoolCycleAction from "../WorkerPool/CycleAction";
import WorkerPoolUpdateAction from "../WorkerPool/UpdateAction";
import { showCycleConfirmation } from "../WorkerPool/CycleConfirmation";
import { showDeleteConfirmation } from "../WorkerPool/DeleteConfirmation";
import { showResetConfirmation } from "../WorkerPool/ResetConfirmation";

type PrivateWorkerPoolActionsDropdownProps = {
  onEdit: () => void;
  workerPool: WorkerPool;
};

const PrivateWorkerPoolActionsDropdown = ({
  onEdit,
  workerPool,
}: PrivateWorkerPoolActionsDropdownProps) => {
  const handleOnCycle = () => {
    showCycleConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  const handleOnReset = () => {
    showResetConfirmation({ id: workerPool.id, name: workerPool.name, viewPageMode: true });
  };

  const handleOnDelete = () => {
    showDeleteConfirmation({ id: workerPool.id, name: workerPool.name, viewPageMode: true });
  };

  return (
    <DropdownMenuEllipsis dotsSize="medium" tooltip="Worker pool actions">
      <CopyFieldDropdownMenuItem title="Copy ID" value={workerPool.id} />
      <WorkerPoolUpdateAction onAction={onEdit} workerPool={workerPool} />
      <WorkerPoolCycleAction onAction={handleOnCycle} workerPool={workerPool} />
      <WorkerPoolResetAction onAction={handleOnReset} workerPool={workerPool} />
      <WorkerPoolDeleteAction onAction={handleOnDelete} workerPool={workerPool} />
    </DropdownMenuEllipsis>
  );
};

export default memo(PrivateWorkerPoolActionsDropdown);
